import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Client } from '../domain/data';
import { FullClientInterface, Transaction } from '../../core';
import { LocalStorage } from '../client/helpers/local-storage';
import { Serializer } from '../client/helpers/serializer/serializer';
import { UseCase } from '../../core/domain/usecases/common/use.case';

@Injectable()
export class GetClientLocalStorageUseCase implements UseCase<Observable<Transaction<FullClientInterface>>> {
    constructor(private localStorage: LocalStorage, private serializer: Serializer) {}

    bind(): Observable<Transaction<FullClientInterface>> {
        return new Observable((observer) => {
            if (!!this.localStorage.clientJson) {
                const client = this.serializer.fromJson(JSON.parse(this.localStorage.clientJson), Client);
                observer.next(Transaction.success(client));
            }

            observer.complete();
        });
    }
}
